import _ from "lodash";
import { Badge } from "@toddle-edu/ds-web";
import React from "react";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import ACLStore from "lib/aclStore";

export const ASSIGNMENT_AND_PROJECT_STATUS = {
  TO_REVIEW: "TO_REVIEW",
  UNREAD: "UNREAD",
  SCHEDULED: "SCHEDULED",
  ALL_ITEMS: "ALL_ITEMS",
};

export const ASSIGNMENT_PROJECT_CLASS_ROOM_ACTIVE_TAB_MAPPING = {
  TO_REVIEW: "PUBLISHED",
  UNREAD: "UNREAD_MESSAGES",
  SCHEDULED: "SCHEDULED",
  ALL_ITEMS: "ALL_POSTS",
};

export const getOrderByPreference = (displaySettingsValue, selectedTab) => {
  const activeTab = _.get(
    ASSIGNMENT_PROJECT_CLASS_ROOM_ACTIVE_TAB_MAPPING,
    selectedTab
  );
  return _.get(
    displaySettingsValue,
    `${activeTab}.orderByPreference`,
    undefined
  );
};

export const getOrderByDirectionPreference = (
  displaySettingsValue,
  selectedTab
) => {
  const activeTab = _.get(
    ASSIGNMENT_PROJECT_CLASS_ROOM_ACTIVE_TAB_MAPPING,
    selectedTab
  );
  return _.get(
    displaySettingsValue,
    `${activeTab}.orderByDirectionPreference`,
    undefined
  );
};

const styles = {
  labelStyle: {
    marginRight: 4,
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
};

const getLabel = ({ label, count, isStatusWiseCountLoading }) => {
  return (
    <span style={styles.labelContainer}>
      <span style={styles.labelStyle}>{label}</span>
      {!isStatusWiseCountLoading ? (
        <Badge
          dsVersion="2.0"
          placement="left"
          variant="subtle"
          showZero={false}
          value={count}
        />
      ) : (
        <SkeletonLoader height="20px" width="26px" />
      )}
    </span>
  );
};

export const getAssignmentAndProjectStatus = (
  t,
  statusWiseCountMapping,
  isStatusWiseCountLoading
) => {
  const assignmentStatusTabs = [
    {
      value: ASSIGNMENT_AND_PROJECT_STATUS.TO_REVIEW,
      label: getLabel({
        label: t("common:to_review_dash_seperator"),
        count: statusWiseCountMapping[ASSIGNMENT_AND_PROJECT_STATUS.TO_REVIEW],
        isStatusWiseCountLoading,
      }),
    },
    {
      value: ASSIGNMENT_AND_PROJECT_STATUS.UNREAD,
      label: getLabel({
        label: t("common:unread_capital"),
        count: statusWiseCountMapping[ASSIGNMENT_AND_PROJECT_STATUS.UNREAD],
        isStatusWiseCountLoading,
      }),
    },
    {
      value: ASSIGNMENT_AND_PROJECT_STATUS.SCHEDULED,
      label: getLabel({
        label: t("common:scheduled"),
        count: statusWiseCountMapping[ASSIGNMENT_AND_PROJECT_STATUS.SCHEDULED],
        isStatusWiseCountLoading,
      }),
    },
  ];

  if (ACLStore.can("FeatureFlag:AssignmentImprovements")) {
    assignmentStatusTabs.unshift({
      value: ASSIGNMENT_AND_PROJECT_STATUS.ALL_ITEMS,
      label: getLabel({
        label: t("common:all"),
        count: statusWiseCountMapping[ASSIGNMENT_AND_PROJECT_STATUS.ALL_ITEMS],
        isStatusWiseCountLoading,
      }),
    });
  }

  return assignmentStatusTabs;
};

export const NAME = "assignmentAndProject";
const UPDATE_SELECTED_TAB = "UPDATE_SELECTED_TAB" + " " + NAME;

export const updateSelectedTab = payload => {
  return {
    type: UPDATE_SELECTED_TAB,
    payload,
  };
};

const REDUCER_HANDLERS = {
  [UPDATE_SELECTED_TAB]: (state, action) => {
    return {
      ...state,
      selectedTab: action.payload,
    };
  },
};

export const initialState = {
  selectedTab: "TO_REVIEW",
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
